import { CustomValidator } from "../../common/validation/types";
import {
  identifierChanged,
  identifierFeedback,
} from "../../common/validation/identifierValidation";
import { PhonogramValuesType } from "./PhonogramCommonStore";

/**
 * ISRC del fonograma: error si está mal formado o no está en su forma de 12
 * caracteres; aviso si el código de agencia no está en la lista de la IFPI. Solo si el
 * campo cambió contra el original: un fonograma viejo con un ISRC malo se puede seguir
 * editando (el chequeo previo a generar la documentación lo frena igual). Espejo del
 * server (validateIsrcIfChanged).
 *
 * El fonograma solo se edita dentro de la obra: el popup de la grilla valida con este
 * store antes de aplicar la fila, y `original` es la fila tal como estaba al abrirlo.
 *
 * Puro: no escribe en `values`. El getter `warnings` del store lo corre dentro de un
 * computed de MobX, que no admite cambios de estado.
 */
export const phonogramIsrcValidator: CustomValidator<PhonogramValuesType> = {
  name: "phonogramIsrcValidator",
  validate(values, langStore, _cache, original) {
    const errors: Record<string, { message: string; fieldLabel: string }> = {};
    const cardErrors: Record<string, string[]> = {};
    const warnings: Record<string, { message: string; fieldLabel: string }> = {};

    if (identifierChanged(values.isrc, original, "isrc")) {
      const feedback = identifierFeedback("isrc", values.isrc, langStore.language);
      const fieldLabel = langStore.PhonogramIsrcLabel;
      if (feedback.error) errors.isrc = { message: feedback.error, fieldLabel };
      if (feedback.warning) warnings.isrc = { message: feedback.warning, fieldLabel };
    }

    return { errors, cardErrors, warnings };
  },
};
